import Cookies from 'js-cookie';
import { SocketProvider } from '../context/socketContext';
import Login from '../pages/auth/login/Login';
import { useEffect, useState } from 'react';
import { axiosInstanceV2 } from '../services/axios';

const PrivateRoute = ({ children }) => {
	const url = window.location.pathname;

	const [branding, setBranding] = useState(null);
	const [loading, setLoading] = useState(true);
	const [isAuth, setIsAuth] = useState(
		Boolean(Cookies.get('authToken') || localStorage.getItem('authToken')),
	);

	const extractSubDomainFromPath = (pathname) => pathname.match(/^\/user\/([^/]+)/)?.[1] || null;

	useEffect(() => {
		const onAuthChange = () => {
			setIsAuth(Boolean(Cookies.get('authToken') || localStorage.getItem('authToken')));
		};

		window.addEventListener('auth-change', onAuthChange);
		return () => window.removeEventListener('auth-change', onAuthChange);
	}, []);

	useEffect(() => {
		let mounted = true;

		const init = async () => {
			if (isAuth) {
				setLoading(false);
				return;
			}

			const subDomain = extractSubDomainFromPath(url);
			if (!subDomain) {
				setLoading(false);
				return;
			}

			try {
				const res = await axiosInstanceV2.get(`/settings/organisation/branding/${subDomain}`);
				if (mounted) {
					setBranding(res.data?.data?.organisation || null);
				}
			} finally {
				if (mounted) setLoading(false);
			}
		};

		init();
		return () => {
			mounted = false;
		};
	}, [url, isAuth]);

	if (loading) return null;

	if (!isAuth) {
		return <Login branding={branding} />;
	}

	return <SocketProvider>{children}</SocketProvider>;
};

export default PrivateRoute;
